import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import moment from 'moment';
import { getTokens } from '../../styles/tokens';

const useStyles = makeStyles((theme) => {
    const t = getTokens(theme.palette.type, theme.palette.primary.main);
    return {
        // cada observação é um cartão simples: texto, depois autor e data
        note: {
            listStyle: 'none',
            padding: '8px 6px 4px 10px',
            borderRadius: t.radius.md,
            border: `1px solid ${t.line}`,
            backgroundColor: t.muted,
            '& + &': { marginTop: 6 },
        },
        text: {
            fontSize: 13,
            lineHeight: '18px',
            color: t.text,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            paddingRight: 4,
        },
        meta: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 6,
            marginTop: 2,
            minHeight: 28,
        },
        author: {
            minWidth: 0,
            fontSize: 11.5,
            lineHeight: '16px',
            color: t.textSecondary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        remove: {
            flex: 'none',
            width: 28,
            height: 28,
            padding: 0,
            color: t.textMuted,
            '&:hover': { color: t.semantic.error },
            '& svg': { fontSize: 17 },
        },
    };
});

export default function ContactNotesDialogListItem(props) {
    const { note, deleteItem } = props;
    const classes = useStyles();

    const handleDelete = (item) => {
        deleteItem(item);
    }

    return (
        <li className={classes.note}>
            <div className={classes.text}>{note.note}</div>
            <div className={classes.meta}>
                <span className={classes.author}>
                    {note.user.name}, {moment(note.createdAt).format('DD/MM/YY HH:mm')}
                </span>
                <IconButton
                    onClick={() => handleDelete(note)}
                    className={classes.remove}
                    aria-label="Excluir observação"
                >
                    <DeleteOutlineIcon />
                </IconButton>
            </div>
        </li>
    )
}

ContactNotesDialogListItem.propTypes = {
    note: PropTypes.object.isRequired,
    deleteItem: PropTypes.func.isRequired
}
